// extracted by mini-css-extract-plugin
module.exports =  {"live-item":"live-item-y1EOX","channel-card":"channel-card-yXvO4","channel-badge":"channel-badge-x2Jie"};